import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { pageTitle } from '../../helper'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import Spacing from '../Spacing'
import { getServicesData } from '../../data/servicesData.js';
import { Helmet } from 'react-helmet';
import EquipmentTable from '../EquipmentTable';
import Breadcrumbs from '../Breadcrumbs';

export default function ServiceDetailsPage() {
  const { t, i18n } = useTranslation();
  const servicesData = getServicesData(i18n.language === 'en' ? 'en' : 'cs');

  const params = useParams();
  var myServiceData = servicesData.find(item => item.id === params.serviceDetailsId);
  pageTitle("page");
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const plainDescription = myServiceData
    ? myServiceData.description.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
    : '';
  const metaDescription = myServiceData?.seoDescription || (plainDescription.length > 160
    ? plainDescription.substring(0, 157) + '...'
    : plainDescription);
  const pageTitleText = myServiceData?.seoTitle || (myServiceData
    ? `${myServiceData.name} — Stable Records nahrávací studio u Prahy`
    : 'Služby — Stable Records');

  return (
    <>
        <Helmet>
      <title>{pageTitleText}</title>
      <link rel="icon" href="/stablerecords.ico" />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={pageTitleText} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
    </Helmet>
      <PageHeading
        title={myServiceData.name}
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={myServiceData.name}
        parentLinkText={t('serviceDetail.parentServices')}
        parentLink={'/sluzby'}
      />
      <Div className="container">
        <Breadcrumbs items={[
          { label: t('serviceDetail.breadcrumbHome'), href: '/' },
          { label: t('serviceDetail.breadcrumbServices'), href: '/sluzby' },
          { label: myServiceData ? myServiceData.name : '' },
        ]} />
      </Div>

      <Spacing lg='30' md='30'/>
      <Div className="container">
      <Div className="row">
          <Div className="col-xl-5 col-lg-7">
            <SectionHeading
              title={myServiceData.headline}
              subtitle="Stable records studio"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
              <div dangerouslySetInnerHTML={{ __html: myServiceData.description}} />
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2">
            <img
              src={myServiceData.images[1]}
              alt={myServiceData.name}
              className="w-100 cs-radius_15 img-crop"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7">
            <img
              src={myServiceData.images[2]}
              alt={myServiceData.name}
              className="w-100 cs-radius_15  img-crop"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5">
            <img
              src={myServiceData.images[3]}
              alt={myServiceData.name}
              className="w-100 cs-radius_15 img-crop"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
        </Div>
      <Spacing lg='120' md='50'/>
      <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
              <Div className="cs-radius_15 cs-shine_hover_1">
                <img src={myServiceData.images[0]} alt={myServiceData.name} className='cs-radius_15 w-100' />
              </Div>
            <Spacing lg='0' md='40'/>
          </Div>
          <Div className="col-lg-6 offset-xl-1">
            <h2 className="cs-font_50 cs-m0">{t('serviceDetail.includes')}</h2>
            <Spacing lg='50' md='30'/>
            <Div className="row">
            <Div className="col-lg-6">
              <ul>
                {myServiceData.bullets.slice(0, 5).map((bullet, index) => (
                  <React.Fragment key={index}>
                    <li className="cs-bullet" >{bullet}</li>
                    <Spacing lg={index === 5 ? '0' : '20'} md='10'/>
                  </React.Fragment>
                ))}
              </ul>
            </Div>
            <Div className="col-lg-6">
              <ul>
                {myServiceData.bullets.slice(5).map((bullet, index) => (
                  <React.Fragment key={index}>
                    <li className="cs-bullet" >{bullet}</li>
                    <Spacing lg='20' md='10'/>
                  </React.Fragment>
                ))}
              </ul>
            </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>

      {params.serviceDetailsId === 'nahravani' && (
      <Div className="container">
        <Div className="row">
        <SectionHeading
              title={t('serviceDetail.equipment')}
              subtitle=""
            >
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
        <Div className="cs-image_layer cs-style1">
          <EquipmentTable />
        </Div>
        </Div>
      </Div>
      )}
      {params.serviceDetailsId === 'nahravani' && (
        <Div className="container" style={{marginTop: '80px'}}>
          <Spacing lg='30' md='20'/>
          <SectionHeading
            title={t('serviceDetail.firstRecording')}
            subtitle={t('serviceDetail.forBeginners')}
          />
          <Spacing lg="50" md="30" />
          <Div className="row">
            <Div className="col-lg-6">
              <h3 className="cs-font_22 cs-m0" style={{marginBottom: '12px'}}>{t('serviceDetail.whatToBring')}</h3>
              <p>{t('serviceDetail.whatToBringText')}</p>
              <Spacing lg="30" md="20" />
              <h3 className="cs-font_22 cs-m0" style={{marginBottom: '12px'}}>{t('serviceDetail.mustPlayPerfect')}</h3>
              <p>{t('serviceDetail.mustPlayPerfectText')}</p>
            </Div>
            <Div className="col-lg-6">
              <h3 className="cs-font_22 cs-m0" style={{marginBottom: '12px'}}>{t('serviceDetail.sessionDuration')}</h3>
              <p>{t('serviceDetail.sessionDurationText')}</p>
              <Spacing lg="30" md="20" />
              <h3 className="cs-font_22 cs-m0" style={{marginBottom: '12px'}}>{t('serviceDetail.firstConsultation')}</h3>
              <p>{t('serviceDetail.firstConsultationText')}</p>
            </Div>
          </Div>
          <Spacing lg="60" md="40" />
        </Div>
      )}
      <Div className="container">
        <Cta
          title={t('serviceDetail.ctaTitle')}
          btnText={t('serviceDetail.ctaBtn')}
          btnLink={'/kontakt'}
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}